// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.list-item-content__actions--primary {
	display: flex;
	justify-content: space-between;
}
.list-item-content__actions--primary .action--primary .action-button {
	align-items: center;
	flex-direction: column;
	padding: 10px 10px 0 10px;
.material-design-icon {
		margin-bottom: -15px;
}
}
.list-item-content__actions--primary .action--primary .action-button__text,
.list-item-content__actions--primary .action--primary .action-button__icon {
	height: auto;
}
`, "",{"version":3,"sources":["webpack://./src/components/EnvelopePrimaryActions.vue"],"names":[],"mappings":";AAaA;CACA,aAAA;CACA,8BAAA;AACA;AAEA;CACA,mBAAA;CACA,sBAAA;CACA,yBAAA;AAEA;EACA,oBAAA;AACA;AACA;AAEA;;CAEA,YAAA;AACA","sourcesContent":["<template>\n\t<ul class=\"list-item-content__actions--primary\">\n\t\t<slot />\n\t</ul>\n</template>\n\n<script>\nexport default {\n\tname: 'EnvelopePrimaryActions',\n}\n</script>\n\n<style>\n.list-item-content__actions--primary {\n\tdisplay: flex;\n\tjustify-content: space-between;\n}\n\n.list-item-content__actions--primary .action--primary .action-button {\n\talign-items: center;\n\tflex-direction: column;\n\tpadding: 10px 10px 0 10px;\n\n\t.material-design-icon {\n\t\tmargin-bottom: -15px;\n\t}\n}\n\n.list-item-content__actions--primary .action--primary .action-button__text,\n.list-item-content__actions--primary .action--primary .action-button__icon {\n\theight: auto;\n}\n</style>\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
